import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { FormGroup } from '@angular/forms';

import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { AreaManagementService } from 'src/app/services/area-management/area-management.service';
import { LhFirebaseService } from 'src/app/services/fire/lh-fire.service';

@Component({
    selector: 'app-rating-info',
    templateUrl: './rating-info.component.html',
    styleUrls: ['./rating-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RatingInfoComponent extends BaseInjectorService implements OnInit {
  from:string='';
  areaNameList: any[]=[];
  areaZoneList: any[]=[];
  areaNameListCopy: any[]=[];
  areaZoneListCopy: any[]=[];
  ratingZoneList:any[]=[];
  ratingZoneListCopy:any[]=[];
  submittedDate: any;
  ratingSubmittedDate: any;
  segmentName:string='';
  searchForm = new FormGroup({});
  zoneForm = new FormGroup({});
  siteForm = new FormGroup({});
  dateForm=new FormGroup({});
  fields: FormlyFieldConfig[] = [
    {
      key: 'search_area',
      type: 'input',
      className: 'rating-info-search',
      props: {
        appearance: 'outline',
        label: this.translate.instant('ASSIGNED_SEARCH'),
        type: 'text',
        disabled: false,
        change: (field, $event) => {
        },
      }
    }
  ];
  zoneField: FormlyFieldConfig[] = [
    {
      key: 'zone_name',
      type: 'input',
      className: 'rating-info-search',
      defaultValue:'',
      props: {
        appearance: 'outline',
        label: this.translate.instant('ASSIGNED_SEARCH'),
        type: 'text',
        disabled: false,
        change: (field, $event) => {
        },
      }
    }
  ];
  dateField:FormlyFieldConfig[]=[
    {
      key: 'dueDateTime',
      type: 'datepicker',
      className: 'rating-info-date',
      props: {
        appearance: 'outline',
        label: this.translate.instant("ACTION.FORM_DUEDATE_PLACEHOLDER"),
        placeholder: 'DD-MM-YYYY',
        required: true,
        disabled:false,
        datepickerOptions: { min: null ,max:null}
      }
    }, 
  ];
  model = {};
  options: FormlyFormOptions = {};
  area_name_list:any[]=[];
  area_name_list_copy:any[]=[];
  area_name_list_array:any=[]=[];
  zoneList: any[]=[];
  zoneListCopy: any[]=[];
  role:any;
  site_name_list:any[]=[];
  site_name_list_copy:any[]=[];
  showData: boolean=true;
  ratingSubmitted:any;
  userTypeRole:any;
  showZone=true;
  btnName: any;
  constructor(private lhFirebaseService: LhFirebaseService,public service:AppService,
    private detectChanges: ChangeDetectorRef,public areaService:AreaManagementService) { super()}

   async ngOnInit() {
    if(this.from=="filter"){
      let previousYearDate=new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      var date = new Date();
      console.log("this.submittedDate=",this.submittedDate);
      if(this.submittedDate){
        this.dateField[0].defaultValue=this.moment(this.submittedDate).format('YYYY-MM-DD');
        this.dateField[0].props.datepickerOptions.min = this.moment(previousYearDate).format('YYYY-MM-DD')
        //this.dateField[0].props.datepickerOptions.max = this.moment(date).format('YYYY-MM-DD')
      }else{
        this.dateField[0].props.datepickerOptions.min = this.moment(previousYearDate).format('YYYY-MM-DD')
        this.dateField[0].props.datepickerOptions.max = this.moment(date).format('YYYY-MM-DD')
      }
    }
    if(this.ratingSubmitted=='area'){
      // if(this.service.appData.userInfo.h_and_s=='Yes'){
      //   this.segmentName='area';
      // }
      // else{
        this.segmentName='zone';
      // }
    }
    else{
      this.segmentName='zone';
    }
    // if(this.userTypeRole){
    //   this.segmentName='site';
    //   console.log("inside if");
    //   //await this.getSiteNameList();
    // }else{
    //   if(this.userTypeRole=='country_admin' || this.userTypeRole=='country_ceo'){
    //     if(isAreaManager && this.ratingSubmitted=='area' && this.service.appData.userInfo.h_and_s=='Yes'){
    //       this.segmentName='area';
    //     }else{
    //       this.segmentName='zone';
    //     }
    //   }else{
    //     if(isAreaManager && this.ratingSubmitted=='area' && this.service.appData.userInfo.h_and_s=='Yes'){
    //       this.segmentName='area';
    //     }else{
    //       this.segmentName='zone';
    //     }
    //   }
      
    // }
  }

 async ionViewDidEnter(){
  console.log( 'ratingSubmitted',this.btnName,"areaZoneList",this.areaZoneList, "areaNameList",this.areaNameList, "areaNameListCopy",this.areaNameListCopy, "areaZoneListCopy",this.areaZoneListCopy, "submittedDate",this.submittedDate,);

  if(this.from=="filter"){
    this.areaNameList = this.areaNameListCopy;
     this.areaZoneList = this.areaZoneListCopy;
     console.log(   '  this.areaZoneList ',  this.areaZoneList ,' this.areaNameList', this.areaNameList );
     
    // if(this.segmentName=='area'){
    //   if(this.userTypeRole){
    //   this.fields[0].formControl.valueChanges
    //   .subscribe(result => {
    //     console.log("result=",result);
    //     if (result == '') { 
    //       this.areaNameList = this.areaNameListCopy; 
    //     } else {
    //         this.areaNameList = this.areaNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
    //     }
    //     this.detectChanges.detectChanges();
    //   });
    // }
    // }
    setTimeout(()=>{
      if(this.ratingSubmitted=='area'){
        if(this.segmentName=='area'){
          console.log("areaNameList=",this.areaNameList);
          this.fields[0].formControl.valueChanges
            .subscribe(result => {
              console.log("res=",result);
              if (result == '') { 
                this.areaNameList = this.areaNameListCopy; 
              } else {
                  this.areaNameList = this.areaNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
              }
              this.detectChanges.detectChanges();
            });
         }
         else  if(this.segmentName=='zone'){
          console.log("areaZoneList=",this.areaZoneList);
          this.zoneField[0].formControl.valueChanges
            .subscribe(result => {
              console.log("res=",result);
              if (result == '') { 
                this.areaZoneList = this.areaZoneListCopy; 
              } else {
                  this.areaZoneList = this.areaZoneListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
              }
              this.detectChanges.detectChanges();
            });
         }
      }
      else if(this.ratingSubmitted=='rating'){
        this.ratingZoneList = this.ratingZoneListCopy;
        console.log('1  this.ratingZoneList ', this.ratingZoneList );
        
        if(this.segmentName=='zone'){
          this.zoneField[0].formControl.valueChanges
            .subscribe(result => {
              console.log("res=",result);
              if (result == '') { 
                this.ratingZoneList = this.ratingZoneListCopy; 
              } else {
                  this.ratingZoneList = this.ratingZoneListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase()));
              }
              this.detectChanges.detectChanges();
            });
         }
      }
      },1000)
  }
  console.log('2  this.ratingZoneList ', this.ratingZoneList );
}

  closeDismiss(){
    this.modalController.dismiss(null);
  }
  dismiss(name){

    if(this.ratingSubmitted=='area'){
      if(this.from=='filter'){
        this.areaDismiss();
      }else{
        this.modalController.dismiss({sortingValue:name});
      }
    }
    else if(this.ratingSubmitted=='rating'){
      if(this.from=='filter'){
        this.ratingDismiss();
      }else{
        this.modalController.dismiss({sortingValue:name});
      }
    }
  }
   areaDismiss(){
    this.zoneList.forEach((element,index) => {
      if(element.selected){
          this.areaZoneList.push(element);
      }else{
        this.areaZoneList.forEach(data => {
          if(data.name==element.name){
            console.log("inside if");
            this.areaZoneList = this.areaZoneList.filter(item => item !== element);
            return;
          }
        });
        
      }
    });
     if("dueDateTime" in this.dateForm.value){
      this.submittedDate=this.dateForm.value;
     }else{
      this.submittedDate=undefined;
     }
     console.log('areaDetails() senting data',this.areaZoneList);
     
    this.modalController.dismiss({areaZoneList:this.areaZoneList,
    submittedDate:this.submittedDate});
  
  }
  ratingDismiss(){
     this.ratingSubmittedDate=this.dateForm.value;
     if("dueDateTime" in this.dateForm.value){
      this.ratingSubmittedDate=this.dateForm.value;
     }else{
      this.ratingSubmittedDate=undefined;
     }
    this.modalController.dismiss({ratingZoneList:this.ratingZoneList,
    ratingSubmittedDate:this.ratingSubmittedDate});
  }
  labelClick(name){
    this.segmentName=name;
    if(this.segmentName=='zone'){
      this.ionViewDidEnter();
    }
  
  }
  selectAreaName(name,index){
    
    if(this.segmentName=='zone'){
      this.areaZoneList[index].selected=!this.areaZoneList[index].selected;
      //this.areaZoneListCopy[index].selected=!this.areaZoneListCopy[index].selected;
      //this.areaZoneList = this.areaZoneList.filter(item => item !== name);
    }else if(this.segmentName=='area'){
      this.areaNameList[index].selected=!this.areaNameList[index].selected;
    }
    else if(this.segmentName=='site'){
      this.site_name_list[index].selected=!this.site_name_list[index].selected;
    }
    
  }
  selectRatingName(name,index){
    if(this.segmentName=='zone'){
      this.ratingZoneList[index].selected=!this.ratingZoneList[index].selected;
      console.log('3    this.ratingZoneList[index].selected',   this.ratingZoneList[index].selected );
    }
  }
  clearFilter(){  
    if(this.ratingSubmitted=='area'){
      this.areaZoneList.forEach(element => {
        element.selected=false;
      });
      this.areaZoneListCopy=this.areaZoneList;
      this.submittedDate=undefined;
      this.modalController.dismiss({areaZoneList:this.areaZoneList,
       submittedDate:this.submittedDate});
    }else{
      this.ratingZoneList.forEach(element => {
        element.selected=false;
      });
      this.ratingZoneListCopy=this.areaZoneList;
      this.ratingSubmittedDate=undefined;
      this.modalController.dismiss({ratingZoneList:this.ratingZoneList,
        ratingSubmittedDate:this.ratingSubmittedDate});
    }  
  }

  async getSiteNameList(){
    let docData:any[]=[]
    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("country", '==', this.service.appData.userInfo.country)
    )
    docInfo.docs?.forEach((doc: any) => {
         docData.push(doc.data().plant_name);
    });
    docData = docData.filter((el, i, a) => i === a.indexOf(el));
    console.log("docData=",docData);
    for(let i=0;i<docData.length;i++){
        console.log("i=",i);
        if(docData[i]!=undefined){
          this.site_name_list.push({name:docData[i],selected:false});
          this.site_name_list_copy.push({name:docData[i],selected:false});
        }  
    }
    
    if(this.site_name_list.length>0){
      this.showData=false;
    } 
  }

}
